import { render, staticRenderFns } from "./AnswerEndArrow.vue?vue&type=template&id=acf4b936&scoped=true&"
import script from "./AnswerEndArrow.vue?vue&type=script&lang=js&"
export * from "./AnswerEndArrow.vue?vue&type=script&lang=js&"
import style0 from "./AnswerEndArrow.vue?vue&type=style&index=0&id=acf4b936&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf4b936",
  null
  
)

export default component.exports